<template>
  <ol
    class="breadcrumb"
    style="
      margin-top: auto;
      margin-bottom: auto;
      margin-left: auto;
      --bs-breadcrumb-divider: '|';
    "
  >
    <!-- groupDevice v-for  如果只有一種key則只顯示 '全部' ，若有一種以上則除了顯示 '全部' 外，其他的也要顯示出來 -->
    <li class="breadcrumb-item" style="color: #0d6efd">
      <button
        class="elecBoard-group-item"
        :class="{ active: groupSelect === 0 }"
        @click="groupSelect = 0"
      >
        全部
      </button>
    </li>
    <li
      v-if="groupList.length > 1"
      v-for="(group, index) in groupList"
      :key="index"
      class="breadcrumb-item"
    >
      <button
        class="elecBoard-group-item"
        :class="{ active: groupSelect === index + 1 }"
        @click="groupSelect = index + 1"
      >
        {{ group }}
      </button>
    </li>
    <!-- <li class="breadcrumb-item">
      <button
        class="elecBoard-group-item"
        :class="{ active: groupSelect == 1 }"
        @click="groupSelect = 1"
      >
        成一組
      </button>
    </li>
    <li class="breadcrumb-item">
      <button
        class="elecBoard-group-item"
        :class="{ active: groupSelect == 2 }"
        @click="groupSelect = 2"
      >
        成二組
      </button>
    </li> -->
  </ol>
</template>
  
  <script>
import { useStore } from "vuex";
import { computed, inject, ref, watch } from "@vue/runtime-core";
export default {
  components: {},
  setup() {
    const groupSelect = inject("groupSelect");
    const deviceData = inject("deviceData");
    const groupDevice = inject("groupDevice");
    const groupList = inject("groupList");

    watch(
      deviceData,
      (newValue) => {
        const groups = new Set();

        // 遍歷 deviceData，將群組名稱添加到 Set 中
        for (const key in newValue) {
          if (newValue[key].group_name) {
            groups.add(newValue[key].group_name);
            if (!groupDevice.value[newValue[key].group_name]) {
              groupDevice.value[newValue[key].group_name] = [];
            }
            groupDevice.value[newValue[key].group_name].push(key);
          }
        }

        // 將 Set 轉換為陣列並賦值給 groupList
        groupList.value = Array.from(groups);
        groupList.value.sort();
        // 確保 groupList 的更新會觸發相關的 UI 更新
        console.log("groupList:", groupList.value);
        console.log("groupDevice:", groupDevice.value);
      },
      { immediate: true }
    );

    return {
      groupSelect,
      groupList,
    };
  },
};
</script>
  
<style></style>